<template>
  <div>
    <el-row ref="searchBox" class="search-box">
      <el-col :span="3">
        <el-input v-model="condition.posSn" clearable placeholder="请输入终端SN" />
      </el-col>
      <el-col :span="3">
        <el-select v-model="condition.amountType" clearable placeholder="请选择终端类型">
          <el-option :value="item.code" :label="item.desc" v-for="item in amountTypeOptions" :key="item.code" />
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select v-model="condition.hasActivate" clearable placeholder="请选择是否激活">
          <el-option :value="Number(item.code)" :label="item.desc" v-for="item in format.getEnumItems('yesOrNo')"
            :key="item.code" />
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select style="width: 100%" v-model="condition.groupId" clearable placeholder="请选择分公司">
          <el-option v-for="item in groupList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select style="width: 100%" v-model="condition.salesId" clearable placeholder="请选择业务员">
          <el-option v-for="item in salesList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select v-model="condition.platfromType" clearable placeholder="请选择平台">
          <el-option :value="item.code" :label="item.desc" v-for="item in platfromTypeOptions" :key="item.code" />
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select v-model="condition.auditStatus" clearable placeholder="请选择审核状态">
          <el-option :value="item.code" :label="item.desc" v-for="item in auditStatusOptions" :key="item.code" />
        </el-select>
      </el-col>
      <el-col :span="16">
        <el-button type="primary" @click="getPage">查询</el-button>
        <el-button type="primary" v-permission="'erp:terminal:hq:allocate'"
          @click="openDiaog('hq_allocate')">总部批量分拨</el-button>
        <el-button type="primary" v-permission="'erp:terminal:branch:allocate'"
          @click="openDiaog('branch_allocate')">分公司批量分拨</el-button>
        <el-button type="primary" v-permission="'erp:terminal:branch:callback'"
          @click="openDiaog('branch_callback')">批量回拨</el-button>
        <excel-import v-permission="'erp:terminal:import'" :fatherMethod="getPage"
          template-name="ErpTerminalInventoryImport.xlsx" url="/erp/terminal/inventory/excelImport"
          template="ErpTerminalInventoryImport.xlsx" class-name="ErpTerminalInventoryImport" title="导入" />
      </el-col>
    </el-row>
    <el-table ref="listTable" v-loading="loading" :data="tableData" :height="tableHeight" border>
      <!-- <el-table-column type="index" label="序号" align="center" width="60" /> -->
      <el-table-column prop="posSn" align="center" min-width="160" label="终端号" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-button type="text" @click="handleEdit(scope.row.id, true)">{{
            scope.row.posSn
            }}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="platfromName" align="center" min-width="160" label="平台名称" show-overflow-tooltip />
      <el-table-column prop="groupName" align="center" min-width="160" label="分公司" show-overflow-tooltip />
      <el-table-column prop="salesName" align="center" min-width="160" label="业务员" show-overflow-tooltip />
      <el-table-column prop="amountType" align="center" min-width="160" label="终端类型" show-overflow-tooltip />
      <el-table-column prop="hasActivate" align="center" min-width="160" label="是否激活" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>
            {{ formatBoolean(scope.row.hasActivate) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="activateTime" align="center" min-width="160" label="激活时间" show-overflow-tooltip />
      <el-table-column prop="auditStatus" align="center" width="120" label="审核状态" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{  scope.row.auditStatus | formatAuditStatus(that) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="180">
        <template slot-scope="scope">
          <el-button v-permission="'erp:terminal:update'" type="text"
            @click="handleEdit(scope.row.id, false)">修改</el-button>
          <el-button v-if="scope.row.hasActivate === 0 && scope.row.currentStage === 0"
            v-permission="'erp:terminal:hq:allocate'" type="text"
            @click="onHandler(scope.row, 'hq_allocate')">总部下拨</el-button>
          <el-button v-if="scope.row.hasActivate === 0 && scope.row.currentStage === 1"
            v-permission="'erp:terminal:branch:allocate'" type="text"
            @click="onHandler(scope.row, 'branch_allocate')">分部下拨</el-button>
          <el-button
            v-if="scope.row.hasActivate === 0 && (scope.row.currentStage === 1 || scope.row.currentStage === 2) && scope.row.auditStatus !== 0"
            v-permission="'erp:terminal:branch:callback'" type="text"
            @click="onHandler(scope.row, 'branch_callback')">回拨</el-button>
          <el-button v-if="scope.row.currentStage === 1 && scope.row.auditStatus === 0"
            v-permission="'erp:terminal:branch:audit'"
            type="text" @click="handleAudit(scope.row.id)">审核</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="flex-center-end" style="margin-top: 10px">
      <pagination :total="pagination.total" :page.sync="pagination.current" :limit.sync="pagination.size"
        @pagination="getPage" />
    </div>

    <AllocateDialog ref="allocateDialogRef" @success="getPage"></AllocateDialog>
    <TerminalEditDialog ref="terminalEditDialogRef" @success="getPage"></TerminalEditDialog>
    <TerminalAuditDialog ref="terminalAuditDialogRef" @success="getPage"></TerminalAuditDialog>
    <TerminalSingleOperationDialog ref="terminalSingleOperationDialogRef" @success="getPage">
    </TerminalSingleOperationDialog>
  </div>
</template>

<script>
import {
  getPage,
  getGroupListToTerminal,
  getUserListByLogin,
  callbackOne,
} from "@/api/erp/terminal/index";
import Pagination from "@/components/Pagination";
import ExcelImport from "@/components/ExcelImport";
import { booleanToStr } from "@/filters";
import format from "@/utils/formatter";
import AllocateDialog from "./AllocateDialog.vue";
import TerminalEditDialog from "./TerminalEditDialog.vue";
import TerminalAuditDialog from "./TerminalAuditDialog.vue";
import TerminalSingleOperationDialog from "./TerminalSingleOperationDialog.vue";
export default {
  name: "ErpItemBrandIndex",
  components: {
    Pagination,
    ExcelImport,
    AllocateDialog,
    TerminalEditDialog,
    TerminalAuditDialog,
    TerminalSingleOperationDialog,
  },
  data() {
    return {
      that: this,
      format,
      tableHeight: window.innerHeight - 245,
      loading: false,
      pagination: {
        total: 0,
        size: 20,
        current: 1,
      },
      condition: {
        posSn: "",
        amountType: "",
        hasActivate: "",
        groupId: "",
        salesId: "",
        platfromType: "",
      },
      tableData: [],
      // 299,399
      amountTypeOptions: [
        { code: 299, desc: "299" },
        { code: 399, desc: "399" },
      ],
      // 平台 0：海科 1：海川通 2：中付 3:嘉联 4:拉卡拉
      platfromTypeOptions: [
        { code: 0, desc: "海科" },
        { code: 1, desc: "海川通" },
        { code: 2, desc: "中付" },
        { code: 3, desc: "嘉联" },
        { code: 4, desc: "拉卡拉" },
      ],
      auditStatusOptions: [
        { code: 0, desc: "待审核" },
        { code: 1, desc: "审核通过" },
        { code: 2, desc: "审核不通过" },
      ],
      groupList: [],
      salesList: [],
    };
  },
  filters: {
    formatAuditStatus(cellValue,that) {
      return that.auditStatusOptions.find(item => item.code === cellValue)?.desc || '-';
    }
  },
  created() {
    this.getPage();
    this.getGroupList();
    this.getUserList();
  },
  methods: {
    formatBoolean(cellValue) {
      return booleanToStr(cellValue);
    },
    openDiaog(type) {
      this.$refs.allocateDialogRef.open({
        actionType: type,
      });
    },
    // 获取分公司列表
    async getGroupList() {
      try {
        const { data } = await getGroupListToTerminal();
        this.groupList = data || [];
      } catch (error) {
        this.$message.error("获取分公司列表异常");
        this.groupList = [];
      }
    },
    // 获取业务员列表
    async getUserList() {
      try {
        const { data } = await getUserListByLogin();
        this.salesList = data || [];
      } catch (error) {
        this.$message.error("获取分公司列表异常");
        this.salesList = [];
      }
    },
    getPage() {
      this.loading = true;
      getPage(this.condition, this.pagination)
        .then((reponse) => {
          const { current, total, size, records } = reponse.data;
          this.tableData = records;
          this.pagination.total = total;
          this.pagination.current = current;
          this.pagination.size = size;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onHandler(row, actionType) {
      if (actionType === "hq_allocate" || actionType === "branch_allocate") {
        // 总部下拨或分部下拨
        this.$refs.terminalSingleOperationDialogRef.open(row, actionType);
      } else if (actionType === "branch_callback") {
        // 回拨 - 显示确认对话框
        this.$confirm("确认要回拨该终端吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.submitSingleCallback(row);
          })
          .catch(() => {
            // 取消操作
          });
      }
    },
    handleAudit(id) {
      this.$refs.terminalAuditDialogRef.open(id);
    },
    // 提交单个终端回拨
    submitSingleCallback(row) {
      callbackOne({
        operationType: 1, // 分公司回拨
        terminalId: row.id,
      })
        .then(() => {
          this.$message.success("回拨成功");
          this.getPage();
        })
        .catch(() => {
          this.$message.error("回拨失败");
        });
    },
    handleEdit(id, isReadOnly = false) {
      this.$refs.terminalEditDialogRef.open(id, isReadOnly);
    },
  },
};
</script>

<style scoped></style>
